'use client';

import ContentAnimation from '@/components/layouts/content-animation';
import Footer from '@/components/layouts/footer';
import Header from '@/components/layouts/header';
import LoadingNew from '@/components/layouts/loadingnew';
import MainContainer from '@/components/layouts/main-container';
import Navbar from '@/components/layouts/navbar';
import NavbarPlant from '@/components/layouts/navbar-plantselection';
import Overlay from '@/components/layouts/overlay';
import ScrollToTop from '@/components/layouts/scroll-to-top';
import Setting from '@/components/layouts/setting';
import Sidebar from '@/components/layouts/sidebar';
import Portals from '@/components/portals';
import {
    Authorization,
    BKGROUND_IMAGE,
    BKGROUND_IMAGE_BOOKSHELF,
    COMPANY_LOGO_BLANK,
    COMPANY_LOGO_BOOKSHELF_BLANK,
    RazorPayOnlyeMails,
    ReleaseForms,
    bookstoreForms,
    cdate,
    dealerForms,
    isBookshelfSubdomain,
    soudaForms,
} from '@/constants/general';
import { showToast } from '@/constants/sweetalerts';
import { getSessionStatus, getUnapprovedDevices, getUserById, updateSession } from '@/lib/actions/user.action';
import { useSessionStore } from '@/state/clerkssn';
import { useUser, useAuth } from '@clerk/nextjs';
import axios, { AxiosError } from 'axios';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from '@/store';
import '../../styles/global.css';
import { ErrorBoundary } from 'react-error-boundary';
import { useAppStore } from '@/state/company';
import { getAllVehicles } from '@/lib/actions/master/vehicle.action';
import { VideoTutorialsGetAllParams } from '@/lib/actions/shared.types';
import { showAlert } from '@/constants/messagebox';
import { getAllVideoTutorials } from '@/lib/actions/general.action';
import LandingPage from './fleetnet/landingpage/page';
import BSLandingPage from './fleetnet/booksellers/page';
import { getAllFinancialYears } from '@/lib/actions/master/accountsledger.action';
import { getSingleCompany } from '@/lib/actions/company.action';

export default function DefaultLayout({ children }: { children: React.ReactNode }) {
    const isDark = useSelector((state: IRootState) => state.themeConfig.theme === 'dark' || state.themeConfig.isDarkMode);
    const [initialLoading, setInitialLoading] = useState(true);
    const [initialUser, setinitialUser] = useState(false);
    const [showLandingPage, setShowLandingPage] = useState(true);

    const { user } = useUser();

    const pathname = usePathname();
    const router = useRouter();

    const skipLayoutPaths = ['/fleetnet/pdf-viewer'];

    const { count, clerkId, sessionId, updatedTime, systemName, update, setSession, resetSession } = useSessionStore();
    const { setSession: setSessionAppStore, clearSession: clearSessionAppStore, getSession } = useAppStore();

    const [superAdmin, setsuperAdmin] = useState<boolean>();
    const [admin, setadmin] = useState(false);
    const [testUser, setTestUser] = useState<boolean>(false);
    const [bookStoreRazorPayMode, setBookStoreRazorPayMode] = useState<boolean>(false);

    const [authorization, setAuthorization] = useState<Authorization[] | null>(null);
    const [forms, setForms] = useState<ReleaseForms[] | null>(null);
    const [companyId, setCompanyId] = useState(0);
    const [companyName, setCompanyName] = useState('');
    const [companyCode, setCompanyCode] = useState('');
    const [companyLogo, setCompanyLogo] = useState('');
    const [groupId, setGroupId] = useState(0);
    const [approvedUsers, setApprovedUsers] = useState<number | undefined>(undefined);
    const [userCount, setUserCount] = useState<number | undefined>(undefined);
    const [isProcessing, setIsProcessing] = useState(true);
    const [isCookieExists, setisCookieExists] = useState(false);
    const [companyCount, setcompanyCount] = useState(0);
    const [isAlertFetched, setIsAlertFetched] = useState(false);
    const [isAlertShown, setIsAlertShown] = useState(false);
    const [alertData, setAlertData] = useState('');

    // const backgroundImage = !(user && companyId > 0) ? `url(${BKGROUND_IMAGE})` : '';
    const backgroundImage = !user && !skipLayoutPaths.includes(pathname) ? `url(${BKGROUND_IMAGE})` : '';
    const backgroundImageBookShelf = !user && !skipLayoutPaths.includes(pathname) ? `url(${BKGROUND_IMAGE_BOOKSHELF})` : '';

    const [tutorials, setTutorials] = useState<VideoTutorialsGetAllParams[] | null>(null);
    const [isFetchingTutorials, setIsFetchingTutorials] = useState(true);

    const [financialYears, setFinancialYears] = useState<{ id: number; name: string; isClosed: boolean; isEditable: boolean }[]>([]);

    const searchParams = useSearchParams(); // Add this line
    const paramkey = isBookshelfSubdomain();
    // console.log('window.location.hostname', window.location.hostname, 'paramkey', paramkey);

    const uuid = searchParams.get('uuid');
    const deviceName = searchParams.get('deviceName');
    const code = searchParams.get('code');
    const url = uuid && deviceName && code ? `?code=${code}&uuid=${uuid}&deviceName=${deviceName}` : '';

    const { signOut } = useAuth();

    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [loggedInSessionId, setLoggedInSessionId] = useState<string | null>(null);

    const setCompanyInitially = async (clerkId: string) => {
        let cuser = await getUserById(clerkId);

        if (paramkey && uuid && code && companyId === 0 && cuser.superAdmin) {
            cuser.companyId = code ? parseInt(code) : 0;
            const company = await getSingleCompany(cuser.companyId);
            cuser.company = company;
            // console.log('cuser', cuser);
            // console.log('paramkey', paramkey, 'uuid', uuid, 'superAdmin', cuser.superAdmin);
        }

        if (cuser && cuser.isActive) {
            await setsuperAdmin(cuser.superAdmin);
            await setadmin(cuser.isAdmin);
            await setTestUser(cuser.testUser);
            // console.log('cuser.permissionSummary', cuser.superAdmin, cuser.isAdmin, cuser.permissionSummary, cuser.permissionRegisters);
            let transformedPermissions: Authorization[] | null = null;
            setForms((cuser as any).forms);
            // console.log('data', groupId, cuser);
            const gid = cuser.company?.groupId ? cuser.company?.groupId : 0;

            if (gid === 2) {
                const forms = await (cuser as any).forms.filter((f: any) => dealerForms.includes(f.id));
                setForms(forms);
            } else if (gid === 3) {
                const forms = await (cuser as any).forms.filter((f: any) => soudaForms.includes(f.id));
                setForms(forms);
            } else if (gid === 4) {
                const forms = await (cuser as any).forms.filter((f: any) => bookstoreForms.includes(f.id));
                setForms(forms);
            } else {
                setForms((cuser as any).forms);
            }

            if (cuser.permissionRegisters) {
                transformedPermissions = cuser.permissionRegisters
                    .filter((perm: any) => gid === 1 || dealerForms.includes(perm.form.id) || soudaForms.includes(perm.form.id) || bookstoreForms.includes(perm.form.id))
                    .map((perm: any) => ({
                        id: perm.id,
                        formId: perm.formId,
                        name: perm.form.name,
                        group: perm.form.group,
                        subgroup: perm.form.subgroup,
                        type: {
                            add: perm.add,
                            edit: perm.edit,
                            delete: perm.delete,
                            view: perm.view,
                            viewatt: perm.viewatt,
                        },
                    }));
                // console.log('transformedPermissions', transformedPermissions);
                await setAuthorization(transformedPermissions || null);
            } else {
                await setAuthorization(null);
            }

            if (companyId === 0 && cuser.company) {
                setCompanyId(cuser.companyId ? cuser.companyId : 0);
                setCompanyName(cuser.company!.name ?? '');
                setCompanyCode(cuser.company!.code ?? '');
                setCompanyLogo(cuser.company!.picture ?? (paramkey ? COMPANY_LOGO_BOOKSHELF_BLANK : COMPANY_LOGO_BLANK));
                setGroupId(cuser.company!.groupId ? cuser.company!.groupId : 0);
                setApprovedUsers(cuser.company!.approvedUsers);
                setUserCount(cuser.company!.userCount);
                setBookStoreRazorPayMode(RazorPayOnlyeMails.includes(cuser.email!) ? true : false);
                // console.log('groupId - init', cuser.company!.groupId);

                const newSession = {
                    companyId: cuser.companyId ? cuser.companyId : 0,
                    companyName: cuser.company!.name ?? '',
                    companyLogo: cuser.company!.picture ?? (paramkey ? COMPANY_LOGO_BOOKSHELF_BLANK : COMPANY_LOGO_BLANK),
                    companyCode: cuser.company!.code ?? '',
                    groupId: cuser.company!.groupId ? cuser.company!.groupId : 0,
                    isSuperAdmin: cuser.superAdmin,
                    isAdmin: cuser.isAdmin,
                    testUser: cuser.testUser,
                    bookstoreRazorPayMode: RazorPayOnlyeMails.includes(cuser.email!) ? true : false,
                    auth: transformedPermissions,
                    forms: (cuser as any).forms,
                };

                await setSessionAppStore(newSession);
                // console.log('Initially Called', companyId, newSession);

                fetchFinancialYears(cuser.companyId ? cuser.companyId : 0);

                return true;
            }

            return false;
        } else {
            setsuperAdmin(false);
            setCompanyId(0);
            setApprovedUsers(undefined);
            setUserCount(undefined);
            setTestUser(false);

            return false;
        }
    };

    const getSelectedCompany = async (value: boolean) => {
        let type: boolean = false;
        if (value === false) {
            setIsProcessing(true);
        }
        // console.log('isProcessing', isProcessing);
        try {
            const cuser = await getUserById(user!.id);

            const { data } = await axios.get('/api/company');
            // console.log('me', 'Hi there', data);
            if (cuser && data && data.companyId) {
                setCompanyId(parseInt(data.companyId));
                setCompanyName(data.companyName);
                setCompanyCode(data.companyCode ?? '');
                setCompanyLogo(data.companyLogo ?? (paramkey ? COMPANY_LOGO_BOOKSHELF_BLANK : COMPANY_LOGO_BLANK));
                setGroupId(parseInt(data.groupId));
                // console.log('groupId - selected', data.groupId);

                // Fetch full company data to get approvedUsers and userCount
                try {
                    const fullCompanyData = await getSingleCompany(parseInt(data.companyId));
                    if (fullCompanyData) {
                        setApprovedUsers(fullCompanyData.approvedUsers);
                        setUserCount(fullCompanyData.userCount);
                    }
                } catch (error) {
                    console.error('Error fetching full company data:', error);
                }

                await setsuperAdmin(cuser.superAdmin);
                await setadmin(cuser.isAdmin);
                await setTestUser(cuser.testUser);
                await setBookStoreRazorPayMode(RazorPayOnlyeMails.includes(cuser.email!) ? true : false);

                let transformedPermissions: Authorization[] | null = null;
                if (data.groupId === 2) {
                    const forms = await (cuser as any).forms.filter((f: any) => dealerForms.includes(f.id));
                    setForms(forms);
                } else if (data.groupId === 3) {
                    const forms = await (cuser as any).forms.filter((f: any) => soudaForms.includes(f.id));
                    setForms(forms);
                } else if (data.groupId === 4) {
                    const forms = await (cuser as any).forms.filter((f: any) => bookstoreForms.includes(f.id));
                    setForms(forms);
                } else {
                    setForms((cuser as any).forms);
                }

                if (cuser.permissionRegisters) {
                    // console.log('transformedPermissions1', cuser.permissionRegisters);
                    transformedPermissions = cuser.permissionRegisters
                        .filter((perm: any) => data.groupId === 1 || dealerForms.includes(perm.form.id) || soudaForms.includes(perm.form.id) || bookstoreForms.includes(perm.form.id))
                        .map((perm: any) => ({
                            id: perm.id,
                            formId: perm.formId,
                            name: perm.form.name,
                            group: perm.form.group,
                            subgroup: perm.form.subgroup,
                            type: {
                                add: perm.add,
                                edit: perm.edit,
                                delete: perm.delete,
                                view: perm.view,
                                viewatt: perm.viewatt,
                            },
                        }));
                    // console.log('transformedPermissions2', transformedPermissions);
                    await setAuthorization(transformedPermissions || null);
                } else {
                    await setAuthorization(null);
                }

                const newSession = {
                    companyId: data.companyId,
                    companyName: data.companyName,
                    companyLogo: data.companyLogo,
                    companyCode: data.companyCode ?? '',
                    groupId: data.groupId,
                    isSuperAdmin: cuser.superAdmin,
                    isAdmin: cuser.isAdmin,
                    testUser: cuser.testUser,
                    bookstoreRazorPayMode: RazorPayOnlyeMails.includes(cuser.email!) ? true : false,
                    auth: transformedPermissions,
                    forms: (cuser as any).forms,
                };

                await setSessionAppStore(newSession);
                // console.log('Selected Company Called', data.companyId, newSession);

                fetchFinancialYears(parseInt(data.companyId));

                if (value === false) {
                    setIsProcessing(false);
                }
                type = true;
            }
        } catch (e) {
            const error = e as AxiosError;
            console.log(error.message);
            if (value === false) {
                setIsProcessing(false);
            }
        } finally {
            // eslint-disable-next-line no-unsafe-finally
            return type;
        }
    };

    const fetchFinancialYears = async (cid: number) => {
        try {
            const fetchedResult: any = await getAllFinancialYears(cid);
            // console.log('fetchedResult', fetchedResult);
            setFinancialYears(fetchedResult);
        } catch (error) {
            console.error('Error fetching financial years:', error);
        }
    };

    const getCompanyCookie = async () => {
        let type: boolean = false;
        try {
            const { data } = await axios.get('/api/company');
            // console.log(data, count);
            if (data) {
                const { message } = data;
                if (message === 'Not Set') {
                    type = false;
                } else {
                    type = true;
                }
            }
        } catch (e) {
            const error = e as AxiosError;
            console.log(error.message);
        } finally {
            // eslint-disable-next-line no-unsafe-finally
            return type;
        }
    };

    const onProcessing = async (value: boolean) => {
        await setIsProcessing(value);
    };

    const onClearCompany = async () => {
        clearSessionAppStore();
        setCompanyId(0);
        setIsAlertFetched(false);
        setCompanyName('');
        setCompanyCode('');
        setApprovedUsers(undefined);
        setUserCount(undefined);
        setCompanyLogo('');
        setisCookieExists(false);
    };

    const onCompanyPopulate = async (value: number) => {
        await setcompanyCount(value);
    };

    useEffect(() => {
        if (user || (paramkey && !(uuid && deviceName))) {
            setShowLandingPage(false);
        } else {
            setShowLandingPage(true);
        }
    }, [user, paramkey, uuid, code, deviceName]);

    useEffect(() => {
        // console.log('router called', pathname, companyId, initialUser, authorization, user);
        // const comp = getSession();
        // console.log('getSession', comp);
        checkAuthorization('router');
    }, [router]);

    // Keep this intact
    useEffect(() => {
        if (initialUser) {
            checkAuthorization('initial');
        }
    }, [initialUser, companyId, pathname]);

    // Keep this intact
    useEffect(() => {
        if (companyId > 0) {
            if (isAlertFetched === false) {
                // Fetch Alert from action
                let alertCount = 0;
                let alertValue = '';

                setIsAlertFetched(true);

                if (groupId === 1) {
                    getAllVehicles(companyId).then((results) => {
                        // if (results) {
                        //     console.log('data', results);
                        // }
                        if (results.filter((d: any) => d.RT === 3).length > 0) {
                            alertValue += `Road Tax is Expired for ${results.filter((d: any) => d.RT === 3).length} vehicle${results.filter((d: any) => d.RT === 3).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.FT === 3).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}Fitness is Expired for ${results.filter((d: any) => d.FT === 3).length} vehicle${results.filter((d: any) => d.FT === 3).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.IN === 3).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}Insurance is Expired for ${results.filter((d: any) => d.IN === 3).length} vehicle${results.filter((d: any) => d.IN === 3).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.NP === 3).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}National Permit is Expired for ${results.filter((d: any) => d.NP === 3).length} vehicle${results.filter((d: any) => d.NP === 3).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.SP === 3).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}State Permit is Expired for ${results.filter((d: any) => d.SP === 3).length} vehicle${results.filter((d: any) => d.SP === 3).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.AT === 3).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}Authorization is Expired for ${results.filter((d: any) => d.AT === 3).length} vehicle${results.filter((d: any) => d.AT === 3).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.RT === 2).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}Road Tax will Soon Expire for ${results.filter((d: any) => d.RT === 2).length} vehicle${results.filter((d: any) => d.RT === 2).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.FT === 2).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}Fitness will Soon Expire for ${results.filter((d: any) => d.FT === 2).length} vehicle${results.filter((d: any) => d.FT === 2).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.IN === 2).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}Insurance will Soon Expire for ${results.filter((d: any) => d.IN === 2).length} vehicle${results.filter((d: any) => d.IN === 2).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.NP === 2).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}National Permit will Soon Expire for ${results.filter((d: any) => d.NP === 2).length} vehicle${results.filter((d: any) => d.NP === 2).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.SP === 2).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}State Permit will Soon Expire for ${results.filter((d: any) => d.SP === 2).length} vehicle${results.filter((d: any) => d.SP === 2).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount <= 1 && results.filter((d: any) => d.AT === 2).length > 0) {
                            alertValue += `${alertCount > 0 ? '~' : ''}Authorization will Soon Expire for ${results.filter((d: any) => d.AT === 2).length} vehicle${results.filter((d: any) => d.AT === 2).length > 1 ? '(s)' : ''}`;
                            alertCount += 1;
                        }

                        if (alertCount >= 2) {
                            alertValue += ' ...';
                        }

                        setAlertData(alertValue);
                    });
                } else if (groupId === 4) {
                    // BookShelf
                    getUnapprovedDevices(companyId).then((results) => {
                        // console.log('Unapproved Devices', results);
                        if (results.length > 0) {
                            alertValue += `You have ${results.length} unapproved device${results.length > 1 ? '(s)' : ''}.~Please approve ${results.length > 1 ? 'them' : 'that'}.`;
                            alertCount += 1;
                        }

                        // if (alertCount >= 2) {
                        //     alertValue += ' ...';
                        // }

                        setAlertData(alertValue);
                    });
                } else {
                    setAlertData('');
                }

                setIsAlertShown(true);
            }
        }
    }, [companyId]);

    useEffect(() => {
        // console.log('useEffect - user, paramkey, groupId, superAdmin', user, paramkey, groupId, superAdmin);
        if (user && groupId && ((!paramkey && groupId === 4) || (paramkey === true && groupId !== 4)) && !superAdmin) {
            const appName = paramkey ? 'BookShelf' : 'FleetNet';
            showAlert({
                title: `Invalid user for ${appName}`,
                message: `You are not authorized to access ${appName}. Please contact your administrator.`, //paramkey:${paramkey}, groupId:${groupId}, superAdmin:${superAdmin}
                type: 'error',
            });
            signOut({
                redirectUrl: `/${paramkey ? url : ''}`,
            });
        } else if (user && groupId === 4 && paramkey && url) {
            if (companyId !== Number(code)) {
                showAlert({
                    title: 'Invalid Company',
                    message: `You are not authorized for this company. Signing out...`,
                    type: 'error',
                });
                // `You are not authorized for this company (${companyId} - ${code}). Signing out...`
                setTimeout(async () => {
                    await signOut({
                        redirectUrl: `/${paramkey ? url : ''}`,
                    });
                    window.location.reload();
                }, 500);
            }
        }
    }, [user, paramkey, groupId, superAdmin, companyId, code]);

    useEffect(() => {
        // console.log('useEffect - uuid, deviceName, router, isLoggingOut', user, uuid, deviceName, router, isLoggingOut, url);
        if (user && uuid && deviceName && url && router && !isLoggingOut) {
            // Add a small delay to ensure all state is properly initialized
            const timeoutId = setTimeout(() => {
                router.replace(`/transaction/booksales${url}`);
            }, 100);

            return () => clearTimeout(timeoutId);
        }
    }, [user, uuid, deviceName, url, router, isLoggingOut]);

    const checkAuthorization = (strCalledFrom: string) => {
        const restrictedPaths = ['/confidential/company', '/confidential/authorization'];
        const comp = getSession();

        // console.log('strCalledFrom', strCalledFrom, superAdmin, comp);

        if (comp) {
            // This means super admin/ admin/ normal user loggedin and company selected
            // console.log('comp', comp, pathname);
            if (comp.companyId && restrictedPaths.includes(pathname)) {
                if ((comp.isAdmin || comp.isSuperAdmin) && pathname === '/confidential/authorization') {
                    // Allow this path
                } else {
                    console.log('Confidential Path2 Found!', pathname, comp.companyId, comp.isSuperAdmin, 'Redirecting to /');
                    router.push(`/${paramkey ? url : ''}`);
                }
            } else {
                // Its Optional to Check with zustand session data as we have already handled in Sidebar and in individual page
            }
        } else if (superAdmin && !restrictedPaths.includes(pathname) && pathname !== '/') {
            // This means super admin loggedin and company not selected
            console.log('Only Confidential Allowed Here!', pathname, superAdmin, 'Redirecting to /');
            router.push(`/${paramkey ? url : ''}`);
        }
    };

    const fetchTutorials = async () => {
        setIsFetchingTutorials(true);

        try {
            const fetchedResult = await getAllVideoTutorials();
            // console.log('fetchedResult', fetchedResult);
            await setTutorials(fetchedResult);
        } catch (error: any) {
            setTutorials([]);
            console.error('Error fetching tutorials data:', error);
            showAlert({ title: 'Tutorial List Fetch Issue!', message: error.toString(), type: 'error' });
        } finally {
            setIsFetchingTutorials(false);
        }
    };

    const getLastSessionDetails = async (sessId: string | null) => {
        if (!sessId) return;

        // console.log('pathname', pathname);
        try {
            // console.log('Checking session status for:', sessId);
            // Add a 1-second timeout to getSessionStatus
            const sessionStatusPromise = getSessionStatus(sessId);
            const timeoutPromise = new Promise((resolve, reject) => setTimeout(() => reject(new Error('Session status request timed out')), 1000));
            const sessionStatus = await Promise.race([sessionStatusPromise, timeoutPromise]);
            // console.log('Session status result:', sessionStatus);

            // Type guard to check if sessionStatus has sessionEndType property
            // Defensive: check for string or object, and log for debugging
            // console.log('Session status in getLastSessionDetails:', sessionStatus);

            // Sometimes sessionStatus may be a plain object, or a JSON string, so parse if needed
            let statusObj: any = sessionStatus;
            if (typeof sessionStatus === 'string') {
                try {
                    statusObj = JSON.parse(sessionStatus);
                } catch {
                    statusObj = {};
                }
            }

            // Log for debugging
            // console.log('Parsed session status:', statusObj, typeof statusObj, 'sessionEndType' in statusObj);

            if (statusObj && typeof statusObj === 'object' && 'sessionEndType' in statusObj) {
                if (statusObj.sessionEndType === 'SESSION.REVOKED') {
                    const res = await showAlert({
                        title: 'Session Terminated',
                        message: 'You have been signed out because you signed in from another device.',
                        type: 'warning',
                        timerDuration: 5000,
                    });

                    if (res) {
                        if (window.gc) {
                            window.gc();
                        }
                        // router.replace(`/${paramkey ? url : ''}`);
                    }
                } else if (uuid && code && deviceName && (statusObj.sessionEndType === 'SESSION.EXPIRED' || statusObj.sessionEndType === 'SESSION.REMOVED')) {
                    window.postMessage(
                        {
                            type: 'Session ended',
                            reason: statusObj.sessionEndType,
                        },
                        '*',
                    );

                    if (window.gc) {
                        window.gc();
                    }
                }
            }
        } catch (error) {
            console.error('Error checking session status:', error);
        }
    };

    useEffect(() => {
        // Set isProcessing to false when page is completely loaded
        const handleLoad = () => {
            setIsProcessing(false);
        };

        // Add event listener for window load
        window.addEventListener('load', handleLoad);

        // If the page is already loaded, set isProcessing to false
        if (document.readyState === 'complete') {
            setTimeout(() => {
                setInitialLoading(false);
                setIsProcessing(false);
            }, 1000);
        }

        // Cleanup the event listener when component unmounts
        return () => {
            window.removeEventListener('load', handleLoad);

            // Force garbage collection suggestions
            if (window.gc) {
                window.gc();
            }
        };
    }, []);

    useEffect(() => {
        let isMounted = true;
        let cleanupFunctions: (() => void)[] = [];

        if (initialUser === false) {
            (async function () {
                try {
                    const isFound = await getCompanyCookie();
                    if (isMounted) setisCookieExists(isFound);
                } catch (error) {
                    console.error('Error getting company cookie:', error);
                }
            })();
        }

        if (user) {
            // console.log('Login User:', user.id);

            // Add timeout for session processing to prevent hanging
            const sessionTimeout = setTimeout(() => {
                // console.warn('Session processing timeout');
                if (isMounted) setInitialLoading(false);
            }, 10000);

            cleanupFunctions.push(() => clearTimeout(sessionTimeout));

            user?.getSessions()
                .then((sa: any) => {
                    if (!isMounted) return;

                    sa.forEach(async (session: any) => {
                        if (!isMounted) return;

                        try {
                            const newSession = {
                                count: count ? count + 1 : 1,
                                clerkId: user.id,
                                sessionId: session.id,
                                pathName: pathname,
                                updatedTime: cdate(),
                                update: true,
                                systemName: `${session.latestActivity.ipAddress} , ${session.latestActivity.city} - ${session.latestActivity.country} - ${session.latestActivity.deviceType}${
                                    session.latestActivity.isMobile ? ' [Mobile]' : ''
                                } - ${session.latestActivity.browserName} [${session.latestActivity.browserVersion}]`,
                            };

                            if (isMounted) {
                                setLoggedInSessionId(session.id);
                                await setSession(newSession);
                            }

                            if (initialUser === false && isMounted) {
                                try {
                                    fetchTutorials();
                                    const singleCompany: boolean = await setCompanyInitially(user.id);

                                    if (singleCompany === true && isMounted) {
                                        const payload = {
                                            companyId,
                                            companyName,
                                            companyLogo,
                                            companyCode,
                                            type: true,
                                        };

                                        try {
                                            await fetch(`/api/company`, {
                                                method: 'POST',
                                                headers: {
                                                    'Content-type': 'application/json',
                                                },
                                                body: JSON.stringify(payload),
                                            });
                                        } catch (err) {
                                            console.log('Error setting company:', err);
                                        }
                                    } else {
                                        const value = await getSelectedCompany(true);
                                        if (value === false && isMounted) {
                                            await onClearCompany();
                                        }
                                    }

                                    if (isMounted) {
                                        await setinitialUser(true);
                                        if (count === 0) {
                                            showToast({ title: 'Signed in successfully.', position: 'bottom-right', type: 'success' });
                                        }
                                    }
                                } catch (error) {
                                    console.error('Error during user initialization:', error);
                                }
                            }

                            if (isMounted) {
                                await setInitialLoading(false);
                            }
                        } catch (error) {
                            console.error('Error processing session:', error);
                            if (isMounted) setInitialLoading(false);
                        }
                    });
                })
                .catch((error) => {
                    console.error('Error getting sessions:', error);
                    if (isMounted) setInitialLoading(false);
                });
        } else if (!user && initialUser && !isLoggingOut) {
            if (pathname === '/') {
                // console.log('Session revoked - handling logout', pathname, loggedInSessionId);
                setTimeout(async () => {
                    await getLastSessionDetails(loggedInSessionId);
                }, 100);
            }
        }

        return () => {
            isMounted = false;
            // Execute all cleanup functions
            cleanupFunctions.forEach((cleanup) => cleanup());
        };
    }, [user, pathname, initialUser]);

    useEffect(() => {
        if (update === true && companyId && !isLoggingOut) {
            // console.log('Session Resetted:', update, count);
            const updateSessionAndReset = async () => {
                try {
                    await updateSession({
                        clerkId: clerkId!,
                        sessionId: sessionId!,
                        lastConnectTime: updatedTime!,
                        sessionEndTime: null,
                        sessionEndType: null,
                        companyId: companyId > 0 ? companyId : null,
                        systemName: systemName!,
                        deviceUUID: uuid ? uuid : null,
                    });
                    resetSession();
                } catch (error) {
                    console.error('Error updating session:', error);
                    // Still reset session even if update fails
                    resetSession();
                }
            };

            updateSessionAndReset();
        }
    }, [update, companyId, isLoggingOut]);

    useEffect(() => {
        // console.log('Current Theme is: ' + isDark);
        const themeElement = document.getElementById('theme') as HTMLAnchorElement;
        themeElement.href = `https://cdn.syncfusion.com/ej2/26.1.35/bootstrap5${isDark ? '-dark' : ''}.css`;
        // themeElement.href = `/syncfusion/bootstrap5${isDark ? '-dark' : ''}.css`;
    }, [isDark]);

    if (isProcessing) {
        return <div className="flex min-h-screen grow items-center justify-center">{<LoadingNew />}</div>;
    }

    return (
        <>
            {/* <Script id="theme">
            </Script> */}
            {/* BEGIN MAIN CONTAINER */}
            {showLandingPage && (paramkey ? <BSLandingPage /> : <LandingPage />)}
            {!showLandingPage && (
                <div
                    className="relative flex min-h-screen flex-col bg-cover bg-fixed bg-no-repeat"
                    style={{
                        backgroundImage: paramkey ? backgroundImageBookShelf : backgroundImage,
                    }}
                >
                    <Overlay />
                    <ScrollToTop />
                    <>
                        {/* BEGIN APP SETTING LAUNCHER */}
                        {user && companyId > 0 && <Setting />}
                        {/* END APP SETTING LAUNCHER */}

                        {user &&
                            (skipLayoutPaths.includes(pathname) ? (
                                <MainContainer>
                                    <ContentAnimation>{children}</ContentAnimation>
                                </MainContainer>
                            ) : (
                                <MainContainer>
                                    <>
                                        {/* BEGIN SIDEBAR */}
                                        {isFetchingTutorials === false && (
                                            <Sidebar
                                                clerkId={clerkId}
                                                companyId={companyId}
                                                companyCode={companyCode}
                                                groupId={groupId}
                                                superAdmin={superAdmin}
                                                admin={admin}
                                                testUser={testUser}
                                                initialUser={initialUser}
                                                companyCount={companyCount}
                                                auth={authorization}
                                                forms={forms}
                                                tutorials={tutorials}
                                            />
                                        )}

                                        {/* END SIDEBAR */}
                                        <div className="main-content flex h-full min-h-screen flex-col">
                                            {/* BEGIN TOP NAVBAR */}
                                            {superAdmin !== undefined && companyId > 0 && (
                                                <Header
                                                    companyId={companyId}
                                                    companyName={companyName}
                                                    companyLogo={companyLogo}
                                                    groupId={groupId}
                                                    superAdmin={superAdmin}
                                                    admin={admin}
                                                    testUser={testUser}
                                                    onProcessing={onProcessing}
                                                    onClearCompany={onClearCompany}
                                                    isAlertShown={isAlertShown}
                                                    setIsAlertShown={setIsAlertShown}
                                                    alertData={alertData}
                                                    auth={authorization}
                                                    forms={forms}
                                                    financialYears={paramkey ? undefined : financialYears}
                                                    approvedUsers={approvedUsers}
                                                    userCount={userCount}
                                                />
                                            )}

                                            <ErrorBoundary fallback={<div>Something went wrong</div>}>
                                                {companyId === 0 && (
                                                    <NavbarPlant
                                                        clerkId={clerkId}
                                                        superAdmin={superAdmin}
                                                        admin={admin}
                                                        testUser={testUser}
                                                        isCookieExists={isCookieExists}
                                                        onValueChange={getSelectedCompany}
                                                        onProcessing={onProcessing}
                                                        onCompanyPopulate={onCompanyPopulate}
                                                    />
                                                )}
                                            </ErrorBoundary>
                                            {/* END TOP NAVBAR */}

                                            {/* BEGIN CONTENT AREA */}
                                            {/* {companyId > 0 && (isProcessing ? <LoadingNew /> : <ContentAnimation>{children}</ContentAnimation>)} */}

                                            {/* {isProcessing === true && <div className="flex grow items-center justify-center">{<LoadingNew />}</div>}
                                        {isProcessing === false && <ContentAnimation>{children}</ContentAnimation>} */}
                                            <div className="grow">
                                                <ContentAnimation>{children}</ContentAnimation>
                                            </div>

                                            {/* END CONTENT AREA */}

                                            {/* BEGIN FOOTER */}
                                            <Footer textDark={true} bookStoreRazorPayMode={bookStoreRazorPayMode} />
                                            {/* END FOOTER */}
                                            <Portals />
                                        </div>
                                    </>
                                </MainContainer>
                            ))}
                        {/* {user && companyId === 0 && (
                        <div className="main-content flex min-h-screen flex-col">
                            <NavbarPlant clerkId={clerkId} superAdmin={superAdmin} admin={admin} isCookieExists={isCookieExists} onValueChange={getSelectedCompany} onProcessing={onProcessing} />
                            <div className="flex grow items-center justify-center">{isProcessing ? <LoadingNew /> : children}</div>
                            <Footer textDark={false} />
                            <Portals />
                        </div>
                    )} */}

                        {!user && (
                            <div className="main-content flex min-h-screen flex-col">
                                {/* !initialLoading */}
                                <Navbar showButtons={true} isLoading={false} landingPage={true} />
                                <div className="flex grow items-center justify-center">{isProcessing ? <LoadingNew /> : children}</div>
                                <Footer textDark={false} bookStoreRazorPayMode={bookStoreRazorPayMode} />
                                <Portals />
                            </div>
                        )}
                    </>
                </div>
            )}
        </>
    );
}
